import {EntityType} from "../../../gd/const/item"
import {DeltaEventMethodType} from "../../../gd/manager/delta-handler/types"
import {checkMeetingRelevance} from "./meeting"
import Resources from "../../resources"
import {checkExpenseRelevance} from "./expense"
import {checkTaskRelevance} from "./task"
import {checkEventRelevance} from "./event"

export function resourcesDeltaHandler_checkRelevance(resources:Resources, entityType:EntityType, method: DeltaEventMethodType, header:any, data:any) {

    switch (entityType) {

        case EntityType.MEETING:
            return checkMeetingRelevance(resources, method, data, header)

        case EntityType.TASK:
            return checkTaskRelevance(resources, method, data, header)

        case EntityType.EVENT:
            return checkEventRelevance(resources, method, data, header)

        case EntityType.EXPENSE:
            return checkExpenseRelevance(resources, method, data, header)


        default:
            console.log("ResourceDeltaHAnderl - relevance - unknown type #039487dkd ")
            return true
    }






}